import React from 'react'
import PropTypes from 'prop-types'
import StatusChip from './StatusChip'
import { FUNDING, chipOf, fundingChips } from '../constants'

/** One funding state of a created row's enquiry (funded | pending_payment | parked | canceled | …). */
export function FundingChip({ bucket, count }) {
  const { label, color } = chipOf(FUNDING, bucket)
  return <StatusChip label={count === undefined ? label : `${count} ${label}`} color={color} />
}

FundingChip.propTypes = {
  bucket: PropTypes.string.isRequired,
  count: PropTypes.number,
}

/**
 * The funding of a batch's created rows (its funding{} counts, live from the
 * enquiries): one chip per state that has any; `empty` when none has.
 */
export default function FundingChips({ funding, empty = null }) {
  const chips = fundingChips(funding)
  if (!chips.length) return empty
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {chips.map((chip) => (
        <FundingChip key={chip.bucket} bucket={chip.bucket} count={chip.count} />
      ))}
    </div>
  )
}

FundingChips.propTypes = {
  funding: PropTypes.objectOf(PropTypes.number),
  empty: PropTypes.node,
}
